// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {getTicketsService} from "../services/getTickets.service"; // Import your service

const useGetTickets = (page = 1, limit = 20) => {
  const {data, isError, isLoading, isSuccess, error} = useQuery({
    queryKey: ["raffleTickets", page, limit],
    queryFn: () => getTicketsService(page, limit),
    keepPreviousData: true, // Important for smooth pagination transitions
    placeholderData: [], // Optional, provide initial data if needed
  });

  return {data: data?.data?.data?.tickets, isError, isLoading, isSuccess, error};
};

export default useGetTickets;
